
import Component from 'vue-class-component';
import {
  RequirementsClient, 
  StateFeeRequirementViewModel
} from "@/api-client";
import {Prop} from "vue-property-decorator";
import RequirementSummary from "@/features/applications/components/RequirementSummary";
import {PaymentDetailsProps} from "@/features/applications/components/requirements/stateFee/StateFeeComponentProps";
import PaymentDetails from "@/features/applications/components/requirements/stateFee/PaymentDetails.vue";

@Component({
  components: {
    PaymentDetails
  }
})
export default class StateFeeRequirementSummary extends RequirementSummary {

  @Prop({required: true})
  requirement!: StateFeeRequirementViewModel;

  props: PaymentDetailsProps | null = null;

  async created() {
    if(this.requirementValue){
      const payment = (await new RequirementsClient().paymentDetails(this.application.id, this.requirement.id)).payment;
      this.props = new PaymentDetailsProps(payment, this.application, this.requirement, true);
    }
  }
}
